export default "__VITE_ASSET__BX$cupxj__"